import { Image } from 'components/Image'
import dynamic from 'next/dynamic'
import { tenant2, WfsPage, FdrPage, FfnPage } from 'utils/environmentConfig'

const AchieveTmLogoSVG = dynamic(() => import('components/Svgs/AchieveTmLogoSVG.js'))
const Website2LogoSVG = dynamic(() => import('components/Svgs/Website2LogoSVG.js'))
const Website3LogoSVG = dynamic(() => import('components/Svgs/Website3LogoSVG.js'))

export const CurrentSvg = ({ siteEnv, ...props }) => {
  switch (siteEnv) {
    case WfsPage:
      return (
        <Image
          src="/wfs-logo-dark.png"
          title="WFS Logo"
          alt="WFS Logo"
          width={246}
          height={87}
          {...props}
        />
      )
    case tenant2:
      return <Website2LogoSVG title="website-tenant-2" alt="website-tenant-2" {...props} />
    case FdrPage:
      return <Website2LogoSVG title="FDR Logo" alt="FDR Logo" {...props} />
    case FfnPage:
      return <Website3LogoSVG title="FFN Logo" alt="FFN Logo" {...props} />
    default:
      return <AchieveTmLogoSVG title="Achieve Logo" alt="Achieve Logo" {...props} />
  }
}
